import { ReactElement } from 'react';
import { Media } from 'src/utils/media';

interface DiscussionCategoryContainerLayoutProps {
  cards: ReactElement[]
  button: ReactElement
  modal: ReactElement
  homepageCategoryHeader: string
}

// eslint-disable-next-line import/prefer-default-export
export const DiscussionCategoryContainerLayout = (
  {
    cards,
    button,
    modal,
    homepageCategoryHeader,
  }: DiscussionCategoryContainerLayoutProps,
) => (
  <div>
    <Media between={['xs', 'md']}>
      <div className="container">
        {button}
        {modal}
      </div>
    </Media>
    <Media greaterThanOrEqual="md">
      <div
        data-testid="discussion-categories"
        className="mt-3.5 mb-[26px] border border-solid border-y-kat-seattle border-x-transparent bg-kat-azure pt-[22px] pb-6.5"
      >
        <div className="container">
          <div className="kat-col-lg-8 kat-offset-lg-2">
            <h3 className="mb-3.5">{homepageCategoryHeader}</h3>
            <div className="grid grid-cols-1 gap-x-4.5 gap-y-2 sm:grid-cols-2">
              {cards}
            </div>
          </div>
        </div>
      </div>
    </Media>
  </div>
);
